if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput) {
        variantInput.disabled = false;
      }

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = this.getCartComponent();

      this.submitButton = this.querySelector('[type="submit"]');

      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    getCartComponent() {
      return (
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer')
      );
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form || !this.submitButton) return;

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }

      const cartIcon = this.querySelector('.la-cart-plus');
      if (cartIcon) {
        cartIcon.classList.add('hidden');
      }

      // Resolve after full DOM parse — cart-drawer is often at end of body
      this.cart = this.getCartComponent();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.dataset.cartType != 'page' && this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }

      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {

          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage =
              this.submitButton.querySelector('.sold-out-message');

            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);

            const label = this.submitButton.querySelector('span');
            if (label) {
              label.classList.add('hidden');
            }

            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  if (this.cart && typeof this.cart.renderContents === 'function') {
                    this.cart.renderContents(response);
                  }
                });
              },
              { once: true }
            );

            quickAddModal.hide(true);
          } else if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(response);
          }
        })
        .catch(() => {
          this.handleErrorMessage(
            (window.cartStrings && window.cartStrings.error) || 'Unable to add item to cart.'
          );
        })
        .finally(() => {
          if (!this.submitButton) return;

          this.submitButton.classList.remove('loading');

          // is-empty is owned by cart-drawer.renderContents on success — do not
          // clear it here on failed adds (would flash a non-empty shell).

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          if (spinner) {
            spinner.classList.add('hidden');
          }

          if (cartIcon) {
            cartIcon.classList.remove('hidden');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}